import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

export default function ExportHeader() {
  const location = useLocation();
  const pathname = location.pathname;
  const initialMenu =
    sessionStorage.getItem("myMenu") ||
    "light-style layout-navbar-fixed layout-compact layout-menu-fixed";
  const initialToggle = sessionStorage.getItem("myToggle") === "true";

  const [menu, setMenu] = useState(initialMenu);
  const [toggle, setToggle] = useState(initialToggle);

  const isImportActive = location.pathname === "/import";
  const isExportActive = location.pathname === "/export";

  useEffect(() => {
    sessionStorage.setItem("myMenu", menu);
    sessionStorage.setItem("myToggle", toggle);

    document.documentElement.className = menu;
    // console.log(`menu : ${menu}`);
  }, [menu, toggle]);

  const changeMenuOnHover = () => {
    if (toggle) {
      setMenu(
        "light-style layout-navbar-fixed layout-compact layout-menu-fixed layout-menu-collapsed layout-menu-hover"
      );
    } else {
      setMenu(
        "light-style layout-navbar-fixed layout-compact layout-menu-fixed"
      );
    }
  };

  const changeMenuOffHover = () => {
    if (toggle) {
      setMenu(
        "light-style layout-navbar-fixed layout-compact layout-menu-fixed layout-menu-collapsed"
      );
    } else {
      setMenu(
        "light-style layout-navbar-fixed layout-compact layout-menu-fixed"
      );
    }
  };

  const changeMenuOnClick = () => {
    setMenu(
      "light-style layout-navbar-fixed layout-compact layout-menu-fixed layout-menu-collapsed"
    );
    setToggle(!toggle);
  };

  return (
    <>
      <aside
        id="layout-menu"
        className="layout-menu menu-vertical menu bg-menu-theme"
        onMouseOver={changeMenuOnHover}
        onMouseOut={changeMenuOffHover}
      >
        <div className="app-brand demo">
          <Link to={"/"} className="app-brand-link">
            <span className="app-brand-logo demo me-1">
            <img src="/logo3.png" style={{width:'50px'}} alt="" />
            </span>
            <span className="app-brand-text demo menu-text fw-semibold ms-2">
              Warehouse
            </span>
          </Link>
          <a
            href="#"
            className="layout-menu-toggle menu-link text-large ms-auto"
          >
            <i
              className="menu-toggle-icon d-xl-block align-middle"
              onClick={changeMenuOnClick}
            />
          </a>
        </div>
        <div className="menu-inner-shadow" />
        <ul className="menu-inner py-1">
          <li className={`menu-item`}>
            <div className="text-center d-flex justify-content-center gap-3">
              <Link to="/import" className="btn btn-label-primary">
                Import
              </Link>
              <Link to="/export" className="btn btn-primary">
                Export
              </Link>
            </div>
          </li>
          <li className={`menu-item ${pathname == "/export" ? "active" : ""}`}>
            <Link to={"/export"} className="menu-link">
              <i className="menu-icon tf-icons ri-home-smile-line" />
              <div data-i18n="Dashboard">Dashboard</div>
            </Link>
          </li>
          <li
            className={`menu-item ${
              pathname == "/export-cargo" ? "active" : ""
            }`}
          >
            <Link to={"/export-cargo"} className="menu-link">
              <i className="menu-icon tf-icons ri-instance-line" />
              <div data-i18n="Cargo">Cargo</div>
            </Link>
          </li>
          <li
            className={`menu-item ${
              pathname == "/export-reports" ? "active" : ""
            }`}
          >
            <Link to={"/export-reports"} className="menu-link">
              <i className="menu-icon tf-icons ri-file-settings-line" />
              <div data-i18n="Reports">Reports</div>
            </Link>
          </li>
          <li
            className={`menu-item ${
              pathname == "/export/jobs" ? "active" : ""
            }`}
          >
            <Link to={"/export/jobs"} className="menu-link">
              <i className="menu-icon tf-icons ri-store-2-line" />
              <div data-i18n="Shifting Jobs">Shifting Jobs</div>
            </Link>
          </li>
          <li
            className={`menu-item ${
              pathname == "/export-revenue" ? "active" : ""
            }`}
          >
            <Link to={"/export-revenue"} className="menu-link">
              <i className="menu-icon tf-icons ri-repeat-line" />
              <div data-i18n="Revenue">Revenue</div>
            </Link>
          </li>
          {/* <li className={`menu-item ${(pathname=='/export-analytics')? 'active' :''}`}>
      <Link to={'/export-analytics'} className="menu-link">
        <i className="menu-icon tf-icons ri-line-chart-line" />
        <div data-i18n="Analytics">Analytics</div>
      </Link>
    </li> */}
          {/* <li className={`menu-item ${(pathname=='/export-cycle-reports')? 'active' :''}`}>
      <Link to={'/export-cycle-reports'} className="menu-link">
        <i className="menu-icon tf-icons ri-exchange-funds-line" />
        <div data-i18n="Cycle-Reports">Cycle Reports</div>
      </Link>
    </li> */}
          {/* <li
            className={`menu-item ${
              pathname == "/export-sjo-jobs" ? "active" : ""
            }`}
          >
            <Link to={"/export-sjo-jobs"} className="menu-link">
              <i className="menu-icon tf-icons ri-sofa-line" />
              <div data-i18n="Jobs">Jobs</div>
            </Link>
          </li> */}
        </ul>
      </aside>
    </>
  );
}
